import { render } from "./PageSidebar.vue?vue&type=template&id=f7b94fd8&scoped=true"
import script from "./PageSidebar.vue?vue&type=script&lang=js"
export * from "./PageSidebar.vue?vue&type=script&lang=js"

import "./PageSidebar.vue?vue&type=style&index=0&id=f7b94fd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7b94fd8"]])

export default __exports__